// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-21436ade]{-webkit-line-clamp:3;max-height:3.375em}.subtitle[data-v-21436ade],.title[data-v-21436ade]{-webkit-box-orient:vertical;display:-webkit-box}.subtitle[data-v-21436ade]{-webkit-line-clamp:2;max-height:2.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
